import { Link, useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";

export const CreditAlert = ({ user }) => {
  const { t, href } = useLang();
  if (user.unlimited || !user.can_use_credits || user.credits > 1) return null;
  const empty = user.credits < 1;
  return (
    <div data-testid={empty ? "credit-alert-empty" : "credit-alert-last"}
      className={`flex flex-wrap items-center gap-4 rounded-xl border p-4 ${empty ? "border-red-200 bg-red-50" : "border-amber-200 bg-amber-50"}`}>
      <AlertTriangle className={`h-5 w-5 shrink-0 ${empty ? "text-red-500" : "text-amber-600"}`} />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-slate-900">{empty ? t("alert.emptyTitle") : t("alert.lastTitle")}</p>
        <p className="text-xs text-slate-600">{t("alert.text")}</p>
      </div>
      <Button asChild className="rounded-full bg-slate-900 hover:bg-slate-800" data-testid="credit-alert-buy-button">
        <Link to={href("pricing")}>{t("alert.cta")}</Link>
      </Button>
    </div>
  );
};

export const GoogleOnlyAlert = ({ user }) => {
  const { t } = useLang();
  const { logout } = useAuth();
  const navigate = useNavigate();
  if (user.can_use_credits) return null;
  const switchAccount = async () => { await logout(); navigate("/entrar"); };
  return (
    <div data-testid="google-only-alert" className="flex flex-wrap items-center gap-4 rounded-xl border border-sky-200 bg-sky-50 p-4">
      <AlertTriangle className="h-5 w-5 shrink-0 text-sky-600" />
      <p className="min-w-0 flex-1 text-sm text-slate-800">{t("alert.googleOnly")}</p>
      <Button onClick={switchAccount} className="rounded-full bg-slate-900 hover:bg-slate-800" data-testid="google-only-switch-button">{t("alert.switchCta")}</Button>
    </div>
  );
};
